"use client";

import Link from "next/link";
import RfpMiniForm from "../rfp-mini-form";

interface RequestFormProps {
  data?: any;
}

const RequestForm = ({ data }: RequestFormProps) => {
  const scheduleCall = data?.schedule_call;
  const contactEmail = data?.contact_email;

  return (
    <section className="relative overflow-hidden bg-white xl:py-[100px] lg:py-[80px] py-[56px]">
      <div className="container ">
        <div className="grid grid-cols-12 items-center gap-y-10 lg:gap-x-12 relative">
          {/* Left Side */}
          <div className="col-span-12 lg:col-span-6">
            <h2 className="md:text-left text-center xl:text-[48px] xl:leading-[62.4px] lg:text-[40px] lg:leading-[52px] text-[30px] leading-[39px] tracking-[1px] font-bold text-black">
              {data?.title}
            </h2>

            {/* {data?.sub_title && (
              <p className="mt-4 text-lg text-secondary-text">
                {data.sub_title}
              </p>
            )} */}

            {(scheduleCall?.href || contactEmail?.href) && (
              <div className="mt-8 flex flex-wrap items-center gap-6">
                {scheduleCall?.href && (
                  <Link
                    href={scheduleCall.href}
                    target={scheduleCall.target || undefined}
                    className="font-semibold text-primary-text underline"
                  >
                    {scheduleCall.label || "Schedule a call"}
                  </Link>
                )}

                {contactEmail?.href && (
                  <Link
                    href={contactEmail.href}
                    target={contactEmail.target || undefined}
                    className="font-semibold text-primary-text underline"
                  >
                    {contactEmail.label || "Email us"}
                  </Link>
                )}
              </div>
            )}
          </div>

          {/* Right Side */}
          <div className="col-span-12 overflow-hidden lg:col-span-6">
            {/* FORM */}
            <div className="bg-[url(/images/Quote-bg.webp)]  bg-no-repeat bg-cover bg-center ">
              <RfpMiniForm
                buttonLabel={data?.button_text || "Submit"}
                className="p-[24px_24px] lg:p-[24px_24px] xl:p-[24px_24px] h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestForm;
